import { Component } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular/standalone';

/** Hosts nested contact routes (form + sent confirmation) under /contact/*. */
@Component({
  selector: 'app-contact-shell',
  standalone: true,
  imports: [IonRouterOutlet],
  template: '<ion-router-outlet></ion-router-outlet>',
})
export class ContactShellComponent {}
